import styled from 'styled-components/native';

export const Header = styled.View`
  padding-vertical: 24px;
`;

export const ModuleList = styled.FlatList`
  padding: 16px;
`;
